import React from 'react';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';

export default function SalesBySupplier(props: any) {
  const { salesBySupplier = [] } = props;
  
  const pieData = {
    labels: salesBySupplier.map((supplier: any) => supplier.supplier_name),
    datasets: [
      {
        data: salesBySupplier.map((supplier: any) => supplier.total_sales),
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#4BC0C0',
          '#9966FF',
          '#FF9F40',
        ],
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: true
  };

  return (
    <div className="pie-chart">
      <div style={{ 
        maxWidth: '600px', 
        maxHeight: '600px', 
        margin: '0 auto',
        width: '100%'
      }}>
        <Pie data={pieData} options={chartOptions} />
      </div>
    </div>
  );
}
